import {useSelector} from "react-redux";
import {RootStateModel} from "../reducers";

export function useTypedSelector<V>(selector: (state: RootStateModel) => V, equalityFn?: (left: V, right: V) => boolean) {
    return useSelector<RootStateModel, V>(selector, equalityFn);
}

